'use client';

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { getProofOfReservesApi } from '@flipster/apis/v1/support';
import { stack } from '@flipster/styled-system/patterns';

import { AddressList } from './address-list';
import { CardList } from './card-list';

export const List = () => {
  const [auditTime, setAuditTime] = useState<string | undefined>();

  const { isFetching, data } = useQuery({
    queryKey: ['getProofOfReservesApi', auditTime],
    queryFn: () => getProofOfReservesApi({ auditTime }),
    select: (res) => res.data,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return (
    <section className={stack({ gap: { base: 48, tablet: 32 } })}>
      <CardList
        isFetching={isFetching}
        auditTimes={data?.auditTimes}
        proofOfReserves={data?.data}
        auditTime={auditTime}
        verificationMechanism={data?.verificationType}
        merkleRootHash={data?.rootHash}
        setAuditTime={setAuditTime}
      />
      <AddressList addresses={data?.addresses} />
    </section>
  );
};
